import { getNormalCouponList, getCouponSeries, receiveCoupon, getCouponList } from '@this/services/coupon';
import { isAlipay } from '@/utils/browser';
import { Toast } from 'vant';
import sampleSize from 'lodash/sampleSize';
import localStorage from '@/utils/localStorage';
const state = {
  normalCouponList: [],
  couponList: [],
  normalCouponMetal: {},
  showCouponPopup: false,
  couponSelected: {},
  couponParams: {},
  showSeriesPopup: false,
  seriesList: [],
  seriesSelected: {},
  showAgreement: true,
  agreementChecked: true,
};

const mutations = {
  setShowCouponPopup(state, bool) {
    state.showCouponPopup = bool;
  },
  setNormalCouponMetal(state, obj) {
    state.normalCouponMetal = obj;
  },
  setCouponSelected(state, obj) {
    state.couponSelected = obj;
  },
  setCouponParams(state, obj) {
    state.couponParams = obj;
  },
  setShowSeriesPopup(state, bool) {
    state.showSeriesPopup = bool;
  },
  setSeriesList(state, list) {
    state.seriesList = list;
  },
  setSeriesSelected(state, obj) {
    state.seriesSelected = obj;
  },
  setShowAgreement(state, bool) {
    state.showAgreement = bool;
  },
  setAgreementChecked(state, bool) {
    state.agreementChecked = bool;
  },
  setCouponStatus(state, num) {
    state.couponSelected.is_client = num;
  },
  setNormalCouponList(state, list) {
    state.normalCouponList = list;
  },
  setCouponList(state, list) {
    state.couponList = list;
  },
};

const actions = {
  // 事件
  getCoupons({ commit, rootState }) {
    const {
      user: { uid },
    } = rootState;
    if (uid) {
      return getCouponList({
        uid,
        regionId: rootState.city.city.cityid,
      }).then((res) => {
        commit('setCouponList', sampleSize(res.data, 4));
      });
    }
  },
  getNormalCouponList({ commit, state, rootState }, { page, size = 10 } = {}) {
    const hasCity = rootState.city.city.cityid;
    if (!hasCity) {
      return;
    }
    const thisPage = page || (state.normalCouponMetal.page || 0) + 1;
    return getNormalCouponList({
      uid: rootState.user.uid,
      regionId: hasCity,
      brandId: rootState.brand.brandSelected.pcauto_id,
      page: thisPage,
      size,
    }).then((res) => {
      if (thisPage === 1) {
        commit('setNormalCouponList', res.data.items);
      } else {
        commit('setNormalCouponList', [...state.normalCouponList, ...res.data.items]);
      }
      commit('setNormalCouponMetal', {
        page: thisPage,
        total: res.data.total,
      });
    });
  },
  async clickCoupon({ commit, dispatch }, { coupon = {}, params = {} } = {}) {
    const { is_client, id } = coupon;
    if (is_client === 1) {
      Toast('已领取该优惠券');
      return;
    }
    const couponCount = localStorage.get('CouponCount') || 0;
    if (couponCount >= 3) {
      Toast('最多领取3张优惠券');
      return;
    }
    commit('setCouponSelected', coupon);
    commit('setCouponParams', params);
    await dispatch('getCouponSeries', id);
  },
  changeShowCouponPopup({ commit, state }, bool) {
    const showCouponPopup = bool ?? !state.showCouponPopup;
    commit('setShowCouponPopup', showCouponPopup);
  },
  changeShowSeriesPopup({ commit, state }, bool) {
    const showSeriesPopup = bool ?? !state.showSeriesPopup;
    commit('setShowSeriesPopup', showSeriesPopup);
  },
  selectSeries({ commit }, series) {
    commit('setSeriesSelected', series);
  },
  async clickReceive({ state, dispatch }) {
    const { showAgreement, agreementChecked, seriesSelected } = state;
    if (showAgreement && !agreementChecked) {
      Toast('需勾选须知说明才能领取');
      return;
    }
    if (!seriesSelected.id) {
      Toast('请先选择意向车系');
      return;
    }
    await dispatch('receiveCoupon');
    dispatch('changeCouponStatus');
    dispatch('hideCouponSeriesPopup');
  },
  changeAgreementChecked({ commit, state }, bool) {
    const agreementChecked = bool ?? !state.agreementChecked;
    commit('setAgreementChecked', agreementChecked);
  },
  gotoAgreement() {
    const link = `https://cat.pangku01.com/static/agreement/index.html`;
    if (isAlipay) {
      ap.pushWindow(link);
    } else {
      window.location.href = link;
    }
  },
  // 步骤
  getCouponSeries({ commit, dispatch }, coupon_id) {
    return getCouponSeries({
      coupon_id,
    }).then((res) => {
      const seriesList = res.data.list;
      if (seriesList.length === 1) {
        commit('setSeriesSelected', seriesList[0]);
        commit('setSeriesList', seriesList);
        dispatch('changeShowCouponPopup', false);
        dispatch('clickReceive');
      } else {
        const noSeries = { name: '请选择意向车系' };
        commit('setSeriesSelected', noSeries);
        commit('setSeriesList', [noSeries, ...seriesList]);
        dispatch('changeShowCouponPopup', true);
      }
      commit('setShowAgreement', res.data.isShow);
    });
  },
  receiveCoupon({ state, rootState }) {
    const {
      couponSelected: { id: coupon_id },
      couponParams,
      seriesSelected: { id: series_id, name: series_name },
    } = state;
    const {
      user: { uid, mid },
      city: {
        city: { cityid: city_id },
        location: { position: location_amap, province: location_province, city: location_city },
      },
    } = rootState;
    const params = {
      uid,
      coupon_id,
      city_id,
      location_amap,
      location_province,
      location_city,
      series_id,
      series_name,
      mid,
      ...couponParams,
    };
    return receiveCoupon(params);
  },
  changeCouponStatus({ commit }) {
    Toast('领取成功，可在支付宝卡包查看');
    commit('setCouponStatus', 1);
    let couponCount = localStorage.get('CouponCount') || 0;
    localStorage.set('CouponCount', ++couponCount);
  },
  hideCouponSeriesPopup({ dispatch }) {
    dispatch('changeShowCouponPopup', false);
    dispatch('changeShowSeriesPopup', false);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
